(() => {
  const fieldName = 'properties[Lieferfenster]';
  const forms = new WeakMap();
  let current = null;
  const bindForm = () => {
    if (!current) return;
    const form = document.querySelector('[data-gcp-form]');
    if (!form || forms.has(form)) return;
    const variant = form.querySelector('input[name="id"]');
    if (String(variant?.value) !== current.variant) return;
    forms.set(form, current.value);
    if (!form.querySelector('input[name="properties[Lieferfenster]"]')) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = fieldName;
      input.value = current.value;
      form.append(input);
    }
  };
  // GPO serializes the actual editor form with FormData. Keep this one existing
  // product-scoped quote even if the option renderer replaces its hidden fields.
  document.addEventListener('formdata', event => {
    const value = forms.get(event.target);
    if (value && !event.formData.has(fieldName)) event.formData.set(fieldName, value);
  }, true);
  new MutationObserver(bindForm).observe(document.documentElement, {childList:true, subtree:true});
  const wrap = original => typeof original !== 'function' ? original : async function(item, ...args) {
    const value = item?.properties?.Lieferfenster;
    current = !item?.properties?._gpo_parent_product_group && typeof value === 'string'
      && value.trim() && value.length <= 2048 ? {variant:String(item.id), value} : null;
    const context = current;
    try {
      const result = await original.call(this, item, ...args);
      if (current === context) bindForm();
      return result;
    } finally {
      if (current === context) current = null;
    }
  };
  const installed = new WeakSet();
  const install = app => {
    if (!app || typeof app !== 'object' || installed.has(app)) return app;
    installed.add(app);
    let handler = wrap(app.handleEditOptions);
    Object.defineProperty(app, 'handleEditOptions', {
      configurable:true, enumerable:true,
      get:() => handler,
      set:value => { handler = wrap(value); }
    });
    return app;
  };
  let config = install(window.GPOConfigs);
  // The vendor replaces its bootstrap object before loading the cart module.
  Object.defineProperty(window, 'GPOConfigs', {
    configurable:true, enumerable:true,
    get:() => config,
    set:value => { config = install(value); }
  });
})();
